import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 1280 1280",
  fill: "#fff",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M0 52A52 52 0 0 1 52 0h261.71a52 52 0 0 1 52 52v261.71a52 52 0 0 1-52 52H52a52 52 0 0 1-52-52ZM0 509.14a52 52 0 0 1 52-52h261.71a52 52 0 0 1 52 52v261.72a52 52 0 0 1-52 52H52a52 52 0 0 1-52-52ZM0 966.29a52 52 0 0 1 52-52h261.71a52 52 0 0 1 52 52V1228a52 52 0 0 1-52 52H52a52 52 0 0 1-52-52ZM914.29 52a52 52 0 0 1 52-52H1228a52 52 0 0 1 52 52v261.71a52 52 0 0 1-52 52H966.29a52 52 0 0 1-52-52ZM914.29 509.14a52 52 0 0 1 52-52H1228a52 52 0 0 1 52 52v261.72a52 52 0 0 1-52 52H966.29a52 52 0 0 1-52-52ZM914.29 966.29a52 52 0 0 1 52-52H1228a52 52 0 0 1 52 52V1228a52 52 0 0 1-52 52H966.29a52 52 0 0 1-52-52ZM457.14 509.14a52 52 0 0 1 52-52h261.72a52 52 0 0 1 52 52v261.72a52 52 0 0 1-52 52H509.14a52 52 0 0 1-52-52Z" }, null, -1)
  ]))]))
}
export default { render: render }